import { Box, Table, Text, TextField } from '@radix-ui/themes'
import { PluginJsonSchema, PluginJsonSchemaProperty } from './plugin-schema-types'
import { formatValueForDisplay } from './plugin-config-coercion'

function isArrayType(schema: PluginJsonSchemaProperty): boolean {
  return schema.type === 'array'
}

type PluginConfigEditorProps = {
  schema: PluginJsonSchema
  values: Record<string, unknown>
  onChange: (values: Record<string, unknown>) => void
  errors?: Record<string, string>
}

export const PluginConfigEditor = ({
  schema,
  values,
  onChange,
  errors,
}: PluginConfigEditorProps) => {
  if (!schema.properties) {
    return null
  }

  const properties = Object.entries(schema.properties)

  const handleFieldChange = (key: string, value: string) => {
    onChange({
      ...values,
      [key]: value,
    })
  }

  return (
    <Table.Root style={{ tableLayout: 'fixed' }}>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell style={{ width: '30%' }}>Key</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Value</Table.ColumnHeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {properties.map(([key, propertyDef]) => {
          const isRequired = schema.required?.includes(key)
          const propertySchema = typeof propertyDef === 'boolean' ? undefined : propertyDef
          const label = propertySchema?.description || key

          return (
            <Table.Row key={key}>
              <Table.Cell>
                {label}
                {isRequired ? <span className="plugin-config-required"> *</span> : ''}
              </Table.Cell>
              <Table.Cell>
                <Box>
                  <TextField.Root
                    value={formatValueForDisplay(values[key])}
                    onChange={(e) => handleFieldChange(key, e.target.value)}
                    placeholder={label}
                    color={errors?.[key] ? 'red' : undefined}
                  />
                  {propertySchema && isArrayType(propertySchema) && (
                    <Text size="1" color="gray">
                      Comma-separated values
                    </Text>
                  )}
                  {errors?.[key] && (
                    <Text size="1" color="red">
                      {errors[key]}
                    </Text>
                  )}
                </Box>
              </Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    </Table.Root>
  )
}
